import styled from 'styled-components';

// ─── Layout principal ─────────────────────────────────────────
export const PageContainer = styled.div`
  display: flex;
  height: calc(100vh - 64px);
  background-color: #F1F2F8;
  overflow: hidden;
`;

// ─── Sidebar ──────────────────────────────────────────────────
export const SidebarContainer = styled.nav`
  width: 250px;
  min-width: 250px;
  background-color: #FCF8F8;
  border-right: 2px solid #ccc;
  border-radius: 0 8px 8px 0;
  box-shadow: 4px 0 10px rgba(0,0,0,0.07);
  overflow-y: auto;
  padding: 8px 4px;
  display: flex;
  flex-direction: column;
`;

export const SearchInput = styled.input`
  width: calc(100% - 16px);
  margin: 4px 8px 8px 8px;
  padding: 6px 8px;
  font-size: calc(var(--app-font-size, 13px) * 0.95);
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: #fff;
  transition: border-color 0.2s;
  
  &:focus {
    outline: none;
    border-color: #86b7fe;
    box-shadow: 0 0 0 1px #86b7fe;
  }
  
  &::placeholder {
    color: #adb5bd;
  }
`;

export const SidebarHeading = styled.div`
  flex-shrink: 0;
  font-size: calc(var(--app-font-size, 13px) * 0.9);
  font-weight: 700;
  color: #495057 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 10px 8px 4px 8px;
  margin-top: ${props => props.$mt ? '8px' : '0'};
`;

export const SidebarLink = styled.a`
  flex-shrink: 0;
  display: block;
  padding: 3px 8px 3px 10px;
  font-size: var(--app-font-size, 13px) !important;
  font-weight: 600 !important;
  color: #111111 !important;
  text-decoration: none !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-left: 6px solid ${props => props.$borderColor || '#ccc'};
  border-bottom: 1px solid rgba(0,0,0,0.06);
  background-color: transparent;
  transition: background 0.15s;
  line-height: 1.6;
  opacity: 1 !important;
  visibility: visible !important;

  &:hover {
    background-color: rgba(0,0,0,0.08);
    color: #000 !important;
  }
`;

export const NoResultsMessage = styled.span`
  font-size: calc(var(--app-font-size, 13px) * 0.95);
  color: #888;
  padding: 4px 12px;
`;

export const ObservacionesLink = styled(SidebarLink)`
  margin-top: 8px;
  border-top: 1px solid #eee;
`;

// ─── Contenido principal ──────────────────────────────────────
export const MainContent = styled.main`
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px 40px 20px;
`;

// ─── Header/Navbar superior ───────────────────────────────────
export const HeaderBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e1e1e1;
  border-radius: 6px;
  padding: 8px 16px;
  margin-bottom: 12px;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(0,0,0,0.25);
`;

export const HeaderTitle = styled.span`
  font-size: 1rem;
  font-weight: 700;
  color: #111111;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const HeaderActions = styled.div`
  position: absolute;
  right: 16px;
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const SaveButton = styled.button`
  position: absolute;
  right: 16px;
  background: white;
  border: none;
  border-radius: 4px;
  padding: 4px 14px;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;

  &:hover { background: #e9ecef; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

// ─── Tarjeta de sección (vacuna o datos del paciente) ─────────
export const SectionCard = styled.div`
  border: 1px solid rgba(0,0,0,0.1);
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  border-radius: 8px;
  margin-bottom: 8px;
  scroll-margin-top: 60px;
`;

export const SectionHeader = styled.div`
  font-weight: 700;
  padding: 6px 12px;
  border-bottom: ${props => props.$expanded ? '1px solid rgba(0,0,0,0.05)' : 'none'};
  border-radius: ${props => props.$expanded ? '8px 8px 0 0' : '8px'};
  font-size: calc(var(--app-font-size, 13px) * 1.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.$bg || '#e9ecef'};
  color: ${props => props.$color || '#212529'};
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s, border-radius 0.2s;

  &:hover {
    filter: brightness(0.96);
  }
`;

export const AccordionIcon = styled.span`
  font-size: calc(var(--app-font-size, 13px) * 1.6);
  line-height: 1;
`;

export const EmptyFieldsMessage = styled.span`
  font-size: calc(var(--app-font-size, 13px) * 0.95);
  color: #6c757d;
`;

export const SectionBody = styled.div`
  padding: 6px 12px 8px 12px;
  background-color: white;
  border-radius: 0 0 8px 8px;
`;

// ─── Fila de campos del formulario ────────────────────────────
export const FieldsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 6px 8px;
  align-items: end;
`;

export const FieldCol = styled.div`
  min-width: 0;
  overflow: hidden;
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: calc(var(--app-font-size, 13px) * 0.75);
  font-weight: 700;
  color: #6c757d;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
`;

export const FieldInput = styled.input`
  width: 100%;
  height: calc(var(--app-font-size, 13px) * 2 + 2px);
  font-size: var(--app-font-size, 13px);
  padding: 0 4px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: white;
  &:focus { outline: none; border-color: #86b7fe; box-shadow: 0 0 0 1px #86b7fe; }
  &:disabled { background-color: #e9ecef; color: #6c757d; cursor: not-allowed; opacity: 0.75; }
`;

export const FieldSelect = styled.select`
  width: 100%;
  height: calc(var(--app-font-size, 13px) * 2 + 2px);
  font-size: var(--app-font-size, 13px);
  padding: 0 2px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: white;
  &:focus { outline: none; border-color: #86b7fe; box-shadow: 0 0 0 1px #86b7fe; }
  &:disabled { background-color: #e9ecef; color: #6c757d; cursor: not-allowed; opacity: 0.75; }
`;

export const SectionDisabledNotice = styled.div`
  font-size: calc(var(--app-font-size, 13px) * 0.85);
  font-family: var(--font-body);
  font-weight: 600;
  color: #6c757d;
  background-color: #f8f9fa;
  border: 1px dashed #ced4da;
  border-radius: 4px;
  padding: 4px 8px;
  margin-bottom: 6px;
`;

export const AlertBanner = styled.div`
  padding: 8px 14px;
  border-radius: 6px;
  margin-bottom: 10px;
  font-size: 0.85rem;
  background-color: ${props => props.error ? '#f8d7da' : '#d1e7dd'};
  color: ${props => props.error ? '#842029' : '#0f5132'};
  border: 1px solid ${props => props.error ? '#f5c2c7' : '#badbcc'};
`;

export const LoadingMessage = styled.p`
  margin: auto;
  color: #6c757d;
  font-size: 1rem;
  text-align: center;
`;
